<template>
    <v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;width:100%;height:100%;background-color:white;">
        <v-layout column fill-height>
            <v-flex d-flex md6>
                <highcharts v-if="load" style="height:100%;width:100%;" :options="chartOptions1"></highcharts>
            </v-flex>
            <v-flex d-flex md6>
                <highcharts v-if="load" style="height:100%;width:100%;" :options="chartOptions2"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>

    import {Chart} from 'highcharts-vue'
    import More from 'highcharts/highcharts-more'
    import Highcharts from 'highcharts'

    import {globalStore} from "../main.js"

    More(Highcharts)

    export default {
        name: "OperationalGraphs",
        components: {
            highcharts: Chart
        },
        data() {
            return {
                chartOptions1: {
                        credits: {
                            enabled: false
                        },
                        time: {
                            useUTC: true
                        },
                        chart: {
                            zoomType: 'xy'
                        },
                        title: {
                            text: undefined
                        },
                        tooltip: {
                            formatter: function () {
                                return this.points.reduce(function (s, point) {
                                    return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                                }, '<b>' + new Date(this.x).toISOString().substring(0,16).replace('T',' ')+ '</b>');
                            },
                            shared: true
                        },
                        yAxis: {
                            title: {
                                text: '[kn]',
                                align: 'high'
                            }
                        },
                        xAxis: {
                            type: 'datetime',
                            title:
                                {
                                    text: 'Time',
                                    align: 'high'
                                },
                            labels: {
                                format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
                            },
                            crosshair: true
                        },
                        exporting: {
                            enabled: false
                        },
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom',
                            floating: true,
                        },
                        series: []
                    },
                chartOptions2: {
                        credits: {
                            enabled: false
                        },
                        time: {
                            useUTC: true
                        },
                        plotOptions: {
                            series:
                                {
                                    events: {
                                        legendItemClick: (e) => {
                                            if (e.target.yAxis.hasVisibleSeries) {
                                                e.target.yAxis.update({
                                                    visible: false
                                                });
                                            }
                                            else {
                                                e.target.yAxis.update({
                                                    visible: true
                                                });

                                            }


                                        }
                                    }
                                }
                        },
                        chart: {
                            zoomType: 'xy'
                        },
                        title: {
                            text: undefined
                        },
                        tooltip: {
                            formatter: function () {
                                return this.points.reduce(function (s, point) {
                                    return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                                }, '<b>' + new Date(this.x).toISOString().substring(0,16).replace('T',' ')+'</b>');
                            },
                            shared: true
                        },
                        xAxis: {
                            type: 'datetime',
                            title: {
                                text: 'Time',
                                align: 'high'
                            },
                            labels: {
                                format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
                            },
                            crosshair: true
                        },
                        yAxis: [],
                        exporting: {
                            enabled: false
                        },
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom',
                            floating: true,
                        },
                        series: []
                    },
                parameters1: ['SOG', 'STW', 'Wind_Speed'],
                parameters2: ['ME_Power_perc', 'ensp', 'Wind_direction_relative'],
                load: false

            };
        },
        mounted() {
            this.setData();
        },
        methods: {
            setData() {
                var mapping = globalStore.mapping[globalStore.selectedIMO],
                    units = globalStore.units[globalStore.selectedIMO],
                    item;

                if (typeof mapping == 'undefined') {
                    mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
                }

                if (typeof units == 'undefined') {
                    units = globalStore.units[Object.keys(globalStore.units)[0]]
                }

                this.chartOptions1.series = [];

                this.chartOptions2.series = [];
                this.chartOptions2.yAxis = [];

                let timeStamps = globalStore.signals.timestamps,
                    useLoad = false;

                if (globalStore.signals[globalStore.signals['lastDate']]['ME_Power_perc'] == -1000)
                    useLoad = true;

                if (timeStamps.indexOf('average') > -1)
                    timeStamps.splice(timeStamps.indexOf('average'), 1);

                for (let p = 0; p < this.parameters1.length; p++) {
                    item = {
                        name: mapping['mapping'][this.parameters1[p]],
                        type: 'spline',
                        data: [],
                        marker: {
                            enabled: false
                        },
                        animation: false,
                        states: {
                            hover: {
                                enabled: false
                            },
                            normal: {
                                animation: false
                            },
                            inactive: {
                                opacity: 1
                            }
                        }
                    };

                    let min, max;

                    for (let i = 0; i < timeStamps.length; i++) {
                        let val = globalStore.signals[timeStamps[i]][this.parameters1[p]];

                        if (val != -1000) {
                            item.data.push([new Date(timeStamps[i]).getTime(), val]);

                            if ((min == undefined) || (min > val)) min = val;

                            if ((max == undefined) || (max < val)) max = val;
                        }
                    }

                    let yMin = min-Math.abs(min*0.1),//Math.floor(min * 0.9),
                        yMax = max+Math.abs(max*0.1);//Math.ceil(max * 1.1);

                        
                    if ((this.chartOptions1.yAxis.min == undefined) || (this.chartOptions1.yAxis.min > yMin)) {
                        this.chartOptions1.yAxis.min = yMin;
                    }

                    if ((this.chartOptions1.yAxis.max == undefined) || (this.chartOptions1.yAxis.max < yMax)) {
                        this.chartOptions1.yAxis.max = yMax;
                    }

                    this.chartOptions1.series.push(item);
                }

                for (let p = 0; p < this.parameters2.length; p++) {
                    var axis = {
                        labels: {
                        },
                        title: {
                            text: mapping['mapping'][this.parameters2[p]] + ' [' + units[this.parameters2[p]] + ']',
                            align: 'high',
                        },
                    };

                    this.chartOptions2.yAxis.push(axis);

                    item = {
                        name: mapping['mapping'][this.parameters2[p]],
                        type: 'spline',
                        data: [],
                        marker: {
                            enabled: false
                        },
                        yAxis: p,
                        animation: false,
                        states: {
                            hover: {
                                enabled: false
                            },
                            normal: {
                                animation: false
                            },
                            inactive: {
                                opacity: 1
                            }
                        }
                    };

                    let min, max;

                    for (let i = 0; i < timeStamps.length; i++) {
                        let val;

                        if ((this.parameters2[p] == 'ME_Power_perc') && (useLoad) && (globalStore.signals[timeStamps[i]]['load'] != -1000)) val = globalStore.signals[timeStamps[i]]['load'] * 100;
                        else val = globalStore.signals[timeStamps[i]][this.parameters2[p]];

                        if (val != -1000) {
                            item.data.push([new Date(timeStamps[i]).getTime(), val]);

                            if ((min == undefined) || (min > val)) min = val;

                            if ((max == undefined) || (max < val)) max = val;
                        }
                    }

                     let yMin = min-Math.abs(min*0.1),//Math.floor(min * 0.9),
                        yMax = max+Math.abs(max*0.1);//Math.ceil(max * 1.1);

                        
                    axis.min = yMin;
                    axis.max = yMax;

                    this.chartOptions2.series.push(item);
                }

                this.load = true;

                globalStore.loading = false;
            }
        },
        computed: {
            dataLoaded: function () {
                return globalStore.type;
            }
        },
        watch: {
            dataLoaded: function () {
                if (this.dataLoaded != '') this.setData();
            }
        }
    };
</script>

<style scoped>
</style>

